import React from 'react';

type BadgeVariant = 'success' | 'warning' | 'danger' | 'primary' | 'streak' | 'outline' | 'glass';

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  children: React.ReactNode;
}

export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ children, variant = 'primary', className = '', ...props }, ref) => {
    const variants: Record<BadgeVariant, string> = {
      success: 'bg-success/15 text-success border border-success/20',
      warning: 'bg-warning/15 text-warning border border-warning/20',
      danger: 'bg-danger/15 text-danger border border-danger/20',
      primary: 'bg-primary/15 text-primary border border-primary/20',
      streak: 'bg-streak/15 text-streak border border-streak/20',
      outline: 'bg-transparent text-tg-text border border-black/10 dark:border-white/10',
      glass: 'glass text-tg-text',
    };

    return (
      <span
        ref={ref}
        className={`
          inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold
          ${variants[variant]}
          ${className}
        `}
        {...props}
      >
        {children}
      </span>
    );
  }
);

Badge.displayName = 'Badge';
